/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { GetApiJingleCollectionsQueryResponse, GetApiJingleCollectionsQueryParams, GetApiJingleCollections400, GetApiJingleCollections401, GetApiJingleCollections403, GetApiJingleCollections500 } from "../../types/GetApiJingleCollections.ts";
import { getApiJingleCollectionsQueryResponseSchema } from "../../zod/JingleCollectionSchemas/getApiJingleCollectionsSchema.ts";

function getGetApiJingleCollectionsUrl() {
  const res = { method: 'GET', url: `/api/jingle-collections` as const }  
  return res
}

/**
 * @summary Получение списка подборок джинглов
 * {@link /api/jingle-collections}
 */
export async function getApiJingleCollections({ params }: { params?: GetApiJingleCollectionsQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetApiJingleCollectionsQueryResponse, ResponseErrorConfig<GetApiJingleCollections400 | GetApiJingleCollections401 | GetApiJingleCollections403 | GetApiJingleCollections500>, unknown>({ method : "GET", url : getGetApiJingleCollectionsUrl().url.toString(), params, ... requestConfig })  
  return getApiJingleCollectionsQueryResponseSchema.parse(res.data)
}